import { render, staticRenderFns } from "./class-profile.vue?vue&type=template&id=735eff86&scoped=true"
import script from "./class-profile.vue?vue&type=script&lang=js"
export * from "./class-profile.vue?vue&type=script&lang=js"
import style0 from "./class-profile.vue?vue&type=style&index=0&id=735eff86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735eff86",
  null
  
)

export default component.exports